export enum FileType {
  PDF = 'pdf',
  EPUB = 'epub',
}

export interface Book {
  _id: string;
  title: string;
  author: string;
  isbn: string;
  description: string;
  category: string;
  publishedYear: number;
  coverImage: string;
  fileUrl: string;
  fileType: FileType;
  pageCount: number;
  downloadable: boolean;
  isDeleted: boolean;
  deletedAt: string | null;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateBookData {
  title: string;
  author: string;
  isbn: string;
  description?: string;
  category?: string;
  publishedYear?: number;
  coverImage?: string;
  fileUrl?: string;
  fileType?: FileType;
  pageCount?: number;
  downloadable?: boolean;
}

export interface UpdateBookData extends Partial<CreateBookData> {}

export interface BooksResponse {
  books: Book[];
  total: number;
  page: number;
  totalPages: number;
}

export interface BooksQueryParams {
  page?: number;
  limit?: number;
  category?: string;
  search?: string;
}
